import { ComputedRef, Ref, ShallowRef, WritableComputedRef, unref } from 'vue';

export function toValue<T>(maybeRefOrGetter: MaybeRefOrGetter<T>): T {
  return maybeRefOrGetter === null
    ? maybeRefOrGetter
    : typeof maybeRefOrGetter === 'function'
      ? (maybeRefOrGetter as () => T)()
      : unref(maybeRefOrGetter);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MaybeRef<T = any> = T | Ref<T> | ShallowRef<T> | WritableComputedRef<T>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MaybeRefOrGetter<T = any> = MaybeRef<T> | ComputedRef<T> | (() => T);
